export default "__VITE_ASSET__3WnQ2g$6__"